import React from 'react';
import SvgIconLoader from '@bit/gerenciatd.unifiedicons.svg-icon-loader';
import SvgIconLabel, {
  SVGICON_LABEL_POSITION,
  COLOR,
} from '@bit/gerenciatd.unifiedicons.svg-icon-label';
import './NoSmartphoneAd.scss';

export const NoSmartphoneAd = ({ dontHaveSmartPhoneAd }) => {
  return (
    <div className="no-smartphone-ad">
      <SvgIconLabel
        id={dontHaveSmartPhoneAd.icon.id}
        kind={dontHaveSmartPhoneAd.icon.color}
        iconSize={32}
        iconColor={dontHaveSmartPhoneAd.icon.color}
        SvgIconLoader={SvgIconLoader}
        labelSize={18}
        label={dontHaveSmartPhoneAd.text}
        labelColor={COLOR.BLACK}
        labelPosition={SVGICON_LABEL_POSITION.RIGHT}
      />
    </div>
  );
};
